var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuEllipsis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85734 1.92867C3.85734 2.99368 2.99391 3.85711 1.92867 3.85711C0.863429 3.85711 0 2.99368 0 1.92867C0 0.863429 0.863429 0 1.92867 0C2.99391 0 3.85734 0.863429 3.85734 1.92867Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85734 9.00008C3.85734 10.0653 2.99391 10.9287 1.92867 10.9287C0.863429 10.9287 0 10.0653 0 9.00008C0 7.93484 0.863429 7.07141 1.92867 7.07141C2.99391 7.07141 3.85734 7.93484 3.85734 9.00008Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85734 16.0715C3.85734 17.1367 2.99391 18.0002 1.92867 18.0002C0.863429 18.0002 0 17.1367 0 16.0715C0 15.0065 0.863429 14.1431 1.92867 14.1431C2.99391 14.1431 3.85734 15.0065 3.85734 16.0715Z",
    fill: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEllipsis);
export default __webpack_public_path__ + "static/media/menu-ellipsis.334ee172900fb161b6ee23f86e66ff6f.svg";
export { ForwardRef as ReactComponent };